import { render, staticRenderFns } from "./intensityReport.vue?vue&type=template&id=228e1d62&scoped=true"
import script from "./intensityReport.vue?vue&type=script&lang=js"
export * from "./intensityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e1d62",
  null
  
)

export default component.exports